import { createEventEmitter } from './EventEmitter';
import { createNotifier } from './createNotifier';

it('add message', () => {
  const emitter = createEventEmitter();
  const Notifier = createNotifier(emitter);

  Notifier.addMessage('test');

  expect(Notifier.isEmpty()).toBe(false);
});

it('consume message', () => {
  const emitter = createEventEmitter();
  const Notifier = createNotifier(emitter);

  Notifier.addMessage('test');

  expect(Notifier.isEmpty()).toBe(false);

  Notifier.getNextMessage();

  expect(Notifier.isEmpty()).toBe(true);
});

it('consume message on empty queue returns undefined', () => {
  const emitter = createEventEmitter();
  const Notifier = createNotifier(emitter);

  expect(Notifier.isEmpty()).toBe(true);

  const newMessage = Notifier.getNextMessage();

  expect(newMessage).toBeUndefined();
});
